import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  /**
   * Weight loss consultation
   */
  {
    // 1
    label:
      "Let's get your latest measurements, that way we can keep track of your results and celebrate with you.",
    field: 'wlProgress',
    type: 'info',
    required: true,
    answer: {
      type: 'list',
      required: true,
      items: [
        {
          label: 'What is your current weight?',
          type: 'number',
          name: 'currentWeight',
          placeholder: 'What is your current weight?'
        },
        {
          label: 'What is your waist measurement (around your belly)?',
          type: 'number',
          name: 'waistMeasurement',
          placeholder: 'What is your waist measurement?',
          required: true
        },
        {
          label:
            'What is your hips measurement (the widest part around your butt)?',
          type: 'number',
          name: 'hipsMeasurement',
          placeholder: 'What is your hips measurement?',
          required: true
        }
      ]
    }
  }
];

export default questionsModels;
